import Dropdown from 'antd/es/dropdown';
import styled from 'styled-components';
import { TDropDownProp } from './Dropdown.type';

const SDropdown = styled(Dropdown)<TDropDownProp>``;

export { SDropdown };
